/**
 * @module FE-CU44_緊急連絡先設定画面_救急情報
 */
import AlsokPanel from './components/AlsokPanel.vue';
import DeleteConfirmModal from './components/modals/DeleteConfirmModal.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU44';

export default {
  name: 'EmergencyContactFirstAidInfoPage',
  components: {
    AlsokPanel,
    DeleteConfirmModal,
  },
  data(vm) {
    return {
      people: [],
      dialog: false,
      valid: true,
      error: {
        hasNameError: false,
      },
      rules: {
        name: [
          (value) =>
            !!value || vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.E0001'),
        ],
      },
      result: [],
      modified: '',
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    isDisabled() {
      return (
        this.people.length === 0 ||
        this.people.length >= CONSTANTS.REGISTRATION_LIMIT.FIRST_AID_INFORMATION
      );
    },
    addButtonIcon() {
      return this.people.length >= CONSTANTS.REGISTRATION_LIMIT.FIRST_AID_INFORMATION
        ? require('@/assets/images/icon/disabled-add.png')
        : require('@/assets/images/icon/add.png');
    },
    currentDisplayType() {
      return this.$store.state.currentDisplayType;
    },
  },
  beforMount() {
    this.$_setLoading(true);
  },
  async mounted() {
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    // 遷移元からtabIndexのパラメータを受け取った場合にタブを切り替える
    if (this.$route.params.tabIndex) {
      this.currentTab = this.$route.params.tabIndex;
    }

    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    let param =
      this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY
        ? '/api/emergencyContactFirstAidInfo/getContactInfoForDisplayDistrict'
        : '/api/emergencyContactFirstAidInfo/getContactInfoForCamera';
    // let param = "post";

    //初期通信が遅いので、通信前に表示
    this.isShowPage = true;

    let method = 'post';

    // 遷移元のパラメータによって対象地区とカメラのどちらかのAPIを実行
    if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
      };
      await this.APP_CU4401(param, queries, method);
    } else {
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
      };
      await this.APP_CU4402(param, queries, method);
    }
  },
  /** @type {Methods} */
  methods: {
    /**
     * 救急情報取得(表示地区)(APP_CU4401)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU4401: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //     },
            //     firstAidInfoList: [
            //       {
            //         name: "山田太郎",
            //         kanaName: "ヤマダタロウ",
            //         gender: 1,
            //         birthdate: "1192-11-11",
            //         pastIllnesses: "高血圧",
            //         medicalInstitutionName: "福岡病院",
            //         address: "福岡県福岡市博多区博多駅中央街1-1",
            //         phoneNumber: "092-111-1111",
            //         responsibleDoctor: "福岡太郎",
            //       },
            //       {
            //         name: "山田花子",
            //         kanaName: "ヤマダハナコ",
            //         gender: 3,
            //         birthdate: "1195-09-01",
            //         pastIllnesses: "なし",
            //         medicalInstitutionName: "札幌病院",
            //         address: "北海道札幌市北区北6条西4丁目",
            //         phoneNumber: "011-222-3333",
            //         responsibleDoctor: "札幌太郎",
            //       },
            //       // {
            //       //   name: null,
            //       //   kanaName: null,
            //       //   gender: null,
            //       //   birthdate: null,
            //       //   pastIllnesses: null,
            //       //   medicalInstitutionName: null,
            //       //   address: null,
            //       //   phoneNumber: null,
            //       //   responsibleDoctor: null,
            //       // },
            //     ],
            //     modified: "2022-05-06 09:00:00",
            //   },
            // };

            // 救急情報リストの件数確認
            this.checkFirstAidInfoList(apiData.contentsInfo.firstAidInfoList);

            this.modified = apiData.contentsInfo.modified;

            const targetItem = apiData.contentsInfo.displayDistrictInfo;

            // ------- データ整形 ---------
            const labels = {
              usagePlan:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.対象地区詳細表示領域.利用プラン',
              customerNumber:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.対象地区詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.対象地区詳細表示領域.警備先名',
              districtSplitNumber:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.対象地区詳細表示領域.地区番号',
              districtSplitName:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.対象地区詳細表示領域.地区名',
              displayDistrictNickname: '',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
            ];
            const planTitles = {
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
            };
            // ListPanelコンポーネント用に整形
            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'displayDistrictNickname') {
                  return;
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU44緊急連絡先設定画面救急情報.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.result = [
                  ...this.result,
                  {
                    id: index,
                    title: labels[key],
                    text: text,
                    // isVuetifyKey: text.includes("$"),
                  },
                ];
              }
            });

            this.people = this.people.filter((person) => this.isExistFirstAidInfo(person));

            this.$emit('get-panel-data', {
              displayItems: this.result,
              title: {
                place: `${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
                type: '$vuetify.FECU44緊急連絡先設定画面救急情報.対象地区',
                typeIsBefore: true,
              },
            });
          },
          (error) => {
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
            } else if (error.message.includes('500')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU44緊急連絡先設定画面救急情報.E0002',
                false,
                false,
                '/sorry'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * 救急情報取得(カメラ)(APP_CU4402)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU4402: async function (param, queries, method) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          () => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     cameraInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //       cameraNickName: "リビングカメラ",
            //       deviceID: "1111",
            //     },
            //     firstAidInfoList: [
            //       {
            //         name: "山田太郎",
            //         kanaName: "ヤマダタロウ",
            //         gender: 2,
            //         birthdate: "1192-11-11",
            //         pastIllnesses: "高血圧",
            //         medicalInstitutionName: "福岡病院",
            //         address: "福岡県福岡市博多区博多駅中央街1-1",
            //         phoneNumber: "092-111-1111",
            //         responsibleDoctor: "福岡太郎",
            //       },
            //       // {
            //       //   name: "山田花子",
            //       //   kanaName: "ヤマダハナコ",
            //       //   gender: 3,
            //       //   birthdate: "1195-09-01",
            //       //   pastIllnesses: "なし",
            //       //   medicalInstitutionName: "札幌病院",
            //       //   address: "北海道札幌市北区北6条西4丁目",
            //       //   phoneNumber: "011-222-3333",
            //       //   responsibleDoctor: "札幌太郎",
            //       // },
            //       {
            //         name: null,
            //         kanaName: null,
            //         gender: null,
            //         birthdate: null,
            //         pastIllnesses: null,
            //         medicalInstitutionName: null,
            //         address: null,
            //         phoneNumber: null,
            //         responsibleDoctor: null,
            //       },
            //     ],
            //     modified: "2022-05-06 09:00:00",
            //   },
            // };

            // データをマッピング
            this.checkFirstAidInfoList(apiData.contentsInfo.firstAidInfoList);

            this.modified = apiData.contentsInfo.modified;

            const targetItem = apiData.contentsInfo.cameraInfo;

            const labels = {
              usagePlan: '$vuetify.FECU44緊急連絡先設定画面救急情報.カメラ詳細表示領域.利用プラン',
              customerNumber:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.カメラ詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.カメラ詳細表示領域.警備先名',
              districtSplitNumber:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.カメラ詳細表示領域.地区番号',
              districtSplitName:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.カメラ詳細表示領域.地区名',
              displayDistrictNickname:
                '$vuetify.FECU44緊急連絡先設定画面救急情報.対象地区詳細表示領域.ニックネーム地区表示',
              deviceID: '$vuetify.FECU44緊急連絡先設定画面救急情報.カメラ詳細表示領域.デバイスID',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
              'deviceID',
            ];
            const planTitles = {
              [CONSTANTS.CAMERA_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.カメラ依頼かけつけプラン',
              [CONSTANTS.CAMERA_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.カメラセルフ監視プラン',
            };
            // ListPanelコンポーネント用に整形
            Object.keys(targetItem).map((key) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU44緊急連絡先設定画面救急情報.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.result = [
                  ...this.result,
                  {
                    title: labels[key],
                    text: text,
                    // isVuetifyKey: text.includes("$"),
                  },
                ];
              }
            });

            this.people = this.people.filter((person) => this.isExistFirstAidInfo(person));

            this.$emit('get-panel-data', {
              displayItems: this.result,
              title: {
                place: `${apiData.contentsInfo.cameraInfo.cameraNickName}`,
                type: '$vuetify.FECU27カメラ設定画面.カメラ',
                typeIsBefore: true,
              },
            });
          },
          (error) => {
            if (error.message.includes('403')) {
              this.$router.replace({
                path: '/top',
              });
            } else if (error.message.includes('500')) {
              this.$errorDialog(
                '$vuetify.メッセージ一覧.FECU44緊急連絡先設定画面救急情報.E0002',
                false,
                false,
                '/sorry'
              );
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 救急情報更新(表示地区)(APP_CO9908)
     * @param {*} id 救急情報リストのインデックス番号
     */
    APP_CO9908: async function (id) {
      let param = '/api/common/updateContactInfoForDisplayDistrict';
      let method = 'post';

      const emptyData = {
        name: null,
        kanaName: null,
        gender: null,
        birthdate: null,
        pastIllnesses: null,
        medicalInstitutionName: null,
        address: null,
        phoneNumber: null,
        responsibleDoctor: null,
      };

      let requestPeople = this.people.map((person) => {
        const shapedPerson = {
          name: person.name,
          kanaName: person.kanaName,
          gender: person.gender,
          birthdate: person.birthdate,
          pastIllnesses: person.pastIllnesses,
          medicalInstitutionName: person.medicalInstitutionName,
          address: person.address,
          phoneNumber: person.phoneNumber,
          responsibleDoctor: person.responsibleDoctor,
        };
        return shapedPerson;
      });

      for (; requestPeople.length < CONSTANTS.REGISTRATION_LIMIT.FIRST_AID_INFORMATION; ) {
        requestPeople.push(emptyData);
      }
      requestPeople[id - 1] = emptyData;

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        modified: this.modified,
        firstAidInfo: requestPeople,
      };

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(() => {
          this.people = this.people.filter((person) => person.id !== id);
          this.informationDialog();
        })
        .catch((error) => {
          if (error.message.includes('400')) {
            this.$errorDialog('$vuetify.メッセージ一覧.FECU44緊急連絡先設定画面救急情報.E0001');
          } else {
            this.$_abnormality(error.response.status);
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 救急情報更新(カメラ)(APP_CO9909)
     * @param {*} id 救急情報リストのインデックス番号
     */
    // APP_CO9909 救急情報更新(カメラ)
    APP_CO9909: async function (id) {
      let param = '/api/common/updateContactInfoForCamera';
      // let param = "post";
      let method = 'post';
      const emptyData = {
        name: null,
        kanaName: null,
        gender: null,
        birthdate: null,
        pastIllnesses: null,
        medicalInstitutionName: null,
        address: null,
        phoneNumber: null,
        responsibleDoctor: null,
      };

      let requestPeople = this.people.map((person) => {
        const shapedPerson = {
          name: person.name,
          kanaName: person.kanaName,
          gender: person.gender,
          birthdate: person.birthdate,
          pastIllnesses: person.pastIllnesses,
          medicalInstitutionName: person.medicalInstitutionName,
          address: person.address,
          phoneNumber: person.phoneNumber,
          responsibleDoctor: person.responsibleDoctor,
        };

        return shapedPerson;
      });

      for (; requestPeople.length < CONSTANTS.REGISTRATION_LIMIT.FIRST_AID_INFORMATION; ) {
        requestPeople.push(emptyData);
      }

      requestPeople[id - 1] = emptyData;

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        deviceID: this.$store.state.deviceID,
        modified: this.modified,
        firstAidInfo: requestPeople,
      };

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(() => {
          this.people = this.people.filter((person) => person.id !== id);
          this.informationDialog();
        })
        .catch((error) => {
          if (error.message.includes('400')) {
            this.$errorDialog('$vuetify.メッセージ一覧.FECU44緊急連絡先設定画面救急情報.E0001');
          } else {
            this.$_abnormality(error.response.status);
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * 削除完了ダイアログ表示処理
     */
    informationDialog: async function () {
      const result = await this.$informationDialog(
        '$vuetify.FECU44緊急連絡先設定画面救急情報.削除が完了しました'
      );
      if (result === true) {
        this.$router.go({
          path: this.$router.currentRoute.path,
          force: true,
        });
      }
    },
    /**
     * 救急情報リストの件数確認処理
     * @param {*} firstAidInfoList 救急情報リスト
     */
    checkFirstAidInfoList(firstAidInfoList) {
      if (firstAidInfoList.length == CONSTANTS.REGISTRATION_LIMIT.FIRST_AID_INFORMATION) {
        firstAidInfoList.forEach((firstAidInfo, idx) => {
          this.people.push({
            id: idx + 1,
            name: firstAidInfo.name,
            kanaName: firstAidInfo.kanaName,
            gender: firstAidInfo.gender,
            birthdate: firstAidInfo.birthdate,
            pastIllnesses: firstAidInfo.pastIllnesses,
            medicalInstitutionName: firstAidInfo.medicalInstitutionName,
            address: firstAidInfo.address,
            phoneNumber: firstAidInfo.phoneNumber,
            responsibleDoctor: firstAidInfo.responsibleDoctor,
          });
        });
      } else {
        let path = '';
        if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
          path = '/displayDistrictAccountManagement';
        } else {
          path = '/cameraAccountManagement';
        }

        this.$errorDialog(
          '$vuetify.メッセージ一覧.FECU44緊急連絡先設定画面救急情報.E0002',
          false,
          false,
          path
        );
      }
    },
    /**
     * nullチェック
     * @param {*} contact 救急情報
     * @returns 成否
     */
    isExistFirstAidInfo(contact) {
      if (
        (contact.name === '' || contact.name === null) &&
        (contact.kanaName === '' || contact.kanaName === null) &&
        (contact.gender === '' || contact.gender === null) &&
        (contact.birthdate === '' || contact.birthdate === null) &&
        (contact.pastIllnesses === '' || contact.pastIllnesses === null) &&
        (contact.medicalInstitutionName === '' || contact.medicalInstitutionName === null) &&
        (contact.address === '' || contact.address === null) &&
        (contact.phoneNumber === '' || contact.phoneNumber === null) &&
        (contact.responsibleDoctor === '' || contact.responsibleDoctor === null)
      ) {
        return false;
      } else {
        return true;
      }
    },
    /**
     * 削除処理
     * @param {*} id 救急情報リストのインデックス番号
     */
    deleteConfirm(id) {
      this.$_setLoading(true);
      // 遷移元の画面によって、APP_CO9908かAPP_CO9909のどちらかを実行
      if (this.$store.state.currentDisplayType === CONSTANTS.DISPLAY_TYPE.HOME_SECURITY) {
        this.APP_CO9908(id);
      } else {
        this.APP_CO9909(id);
      }
    },
    /**
     * 横幅変更処理
     * @param {*} width 横幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
};
